import { createRouter, createWebHistory } from 'vue-router'
import { getAdminToken } from '@/api/kernelBlinkClient'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/s/:code',
      name: 'PublicRedirect',
      component: () => import('@/pages/PublicRedirectPage.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/pages/DashboardPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      redirect: '/dashboard',
    },
  ],
})

router.beforeEach((to, _from, next) => {
  const requiresAuth = to.meta.requiresAuth !== false
  const token = getAdminToken()

  if (requiresAuth && !token) {
    if (to.path !== '/login') {
      next({ path: '/login' })
      return
    }
  }

  if (to.path === '/login' && token) {
    next({ path: '/dashboard' })
    return
  }

  next()
})

export default router
